import React from 'react';

import Layout from '../components/Layout';
import Scroll from '../components/Scroll';

import config from '../../config';
import Footer from '../components/Footer';
import Header from '../components/Header';
import ScrollToTop from '../components/ScrollToTop';


import p17 from '../assets/images/cha2.gif';
import p18 from '../assets/images/channel.gif';

const IndexPage = () => (
  <Layout>
    <Header />

    <div className="col-lg-6">
            <a className="portfolio-item" href="#">
              <span className="caption">
                <span className="caption-content">
                  <h2></h2>
                  <p className="mb-0">
                   <b>Enjoy your Videos with just a click...</b>
                  </p>
                </span>
              </span>
              <img className="img-fluid" src={p17} alt="" />
            </a>


          </div>

   

    


    

    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://youtube.com/" className="btn btn-xl btn-light mr-4">
         Youtube
        </a>
        <a href="https://vimeo.com/" className="btn btn-xl btn-dark">
          Vimeo
        </a>
      </div>
    </section>




 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.vevo.com/" className="btn btn-xl btn-light mr-4">
        Vevo
        </a>
        <a href="https://9gag.com/" className="btn btn-xl btn-dark">
          9GAG
        </a>
      </div>
    </section>


     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.twitch.tv/" className="btn btn-xl btn-light mr-4">
          Twitch
        </a>
        <a href="https://wistia.com/" className="btn btn-xl btn-dark">
          Wistia
        </a>
      </div>
    </section>




 <section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
           <img className="img-fluid" src={p18} alt="" />
          <h2 className="mb-5">Enjoy all your video Streaming site Smartly on the Internet..<i className="fa fa-file-video fa-spin"></i></h2>
        </div>
        
      </div>
    </section>









     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.hulu.com/welcome?orig_referrer=https%3A%2F%2Fcreamyanimation.com%2F10-best-video-websites-like-youtube%2F" className="btn btn-xl btn-light mr-4">
         Hulu
        </a>
        <a href="https://likee.com/" className="btn btn-xl btn-dark">
        Likee
        </a>
      </div>
    </section>






     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://about.instagram.com/blog/announcements/welcome-to-igtv" className="btn btn-xl btn-light mr-4">
         IGTV
        </a>
        <a href="https://www.dailymotion.com/gb" className="btn btn-xl btn-dark">
          Daily Motion
        </a>
      </div>
    </section>



<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.tiktok.com/" className="btn btn-xl btn-light mr-4">
        Tiktok
        </a>
        <a href="https://www.veoh.com/" className="btn btn-xl btn-dark">
        Veoh
        </a>
      </div>
    </section>


<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.metacafe.com/" className="btn btn-xl btn-light mr-4">
         Metacafe
        </a>
        <a href="https://www.brightcove.com/en/" className="btn btn-xl btn-dark">
          Brigthcove
        </a>
      </div>
    </section>











    {/* <section id="contact" className="map">
      <iframe
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
        src="https://maps.google.com/maps?f=q&amp;source=s_q&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A&amp;output=embed"
      ></iframe>
      <br />
      <small>
        <a href="https://maps.google.com/maps?f=q&amp;source=embed&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A"></a>
      </small>
    </section> */}

    <ScrollToTop />
    <Footer />
  </Layout>
);

export default IndexPage;
